<template>
  <div class="container verticalCentred">
    <loading v-if="loading" />
    <div v-if="!consent">
      <div class="form-row justify-content-center">
        <div class="col-md-6 mb-3">
          <h4 class="mb-4 center text-red sans-serifBold">
            <strong
              >Per poter proseguire é necessario prendere visione
              dell'informativa</strong
            >
          </h4>
        </div>
        <div class="col-md-12 mb-3 center">
          <button class="btn btn-primary" v-on:click="checkConsent()">
            accetta
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";

export default {
  name: "confirm",
  data() {
    return {
      result: "Verifica Token",
      status: false,
      loading: false,
    };
  },
  methods: {
    checkConsent: function () {
      axios({
        url: process.env.ROOT_API + "fapi/checkConsent",
        method: "POST",
        data: {
          tk: this.profile,
        },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {})
        .catch((error) => {});
    },
  },
  beforeMount() {
    this.confirm();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/confirm/index.vue